module.exports={
	"Scope": "Organization-List",
	"CoreEntity": "Organization",
	"TitleTemplate": "Organizations",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "OrgListName",
			"PictDashboard": {}
		},
		"Type":
		{
			"Name": "Type",
			"Hash": "OrgListType",
			"PictDashboard": {}
		},
		"City":
		{
			"Name": "City",
			"Hash": "OrgListCity",
			"PictDashboard": {}
		},
		"State":
		{
			"Name": "State",
			"Hash": "OrgListState",
			"PictDashboard": {}
		},
		"Approved":
		{
			"Name": "Approved",
			"Hash": "OrgListApproved",
			"PictDashboard":
			{
				"ValueTemplate": "<div class=\"has-text-centered\">{~HCS:Record.Payload.Approved~}<span class=\"icon has-text-success\"><i class=\"fas fa-circle-check\"></i></span>{~HCE:Record.Payload.Approved~}{~HCS:Record.Payload.Approved:true~}<span class=\"icon has-text-grey\"><i class=\"fas fa-circle-xmark\"></i></span>{~HCE:Record.Payload.Approved:true~}</div>"
			}
		}
	}
}
